<template>
  <div class="sku-order-information">
    <div class="sku-order-information__content">
      <h5 class="title">PRISM Electronics needs:</h5>
      <ul class="list">
        <li>Delivery of <span>300,000 boxes</span> to fill lines by December (100,000 boxes delivered per month)</li>
        <li>They provided specs for a <span>single SKU</span></li>
      </ul>
      <img class="image" src="images/why-digital/manufacturing-benefits/scenario_1_manufacturing_benefits.png" alt="">
    </div>
    <img src="images/why-digital/manufacturing-benefits/ssoi_graph_measures.png" alt="">
  </div>
</template>

<style lang="scss" scoped>
@import "@/scss/views/why-digital/manufacturing-time.scss";
</style>
